import React,{useState, useContext} from 'react';
import Fade from 'react-reveal/Fade';
import { Navbar, Nav } from 'react-bootstrap';
import '../../components/LandingPage/landingpage.css';
import {Link} from 'react-router-dom';
import Logo from '../../components/assets/logo.png';
import Phone from '../../components/assets/phone.svg';
import Calculator from '../../components/HomeCalculation';
import Banner from '../../components/assets/banner.png';
import Wave from '../../components/assets/wave.png';
import { useSnackbar } from "notistack"
import Cookies from "js-cookie"
import axios from "axios"
import { UserContext } from "../../components/UserContext";
import BTCRate from '../../components/BTCRate';
const url = "https://www.bitmasta.io/php/functioned.php"

function Login(props) {
  const [email,setEmail] = useState("")
  const [password,setPassword] = useState("")
  const [forgot,setForgot] = useState(false)
  const [rEmail,setREmail] = useState("")
  const { enqueueSnackbar } = useSnackbar()
  const user = useContext(UserContext);



  const processSubmit = (e) =>{
    e.preventDefault()
    if(email && password){
      let formData = new FormData()
      formData.append("Login_Email",email)
      formData.append("Login_Pass",password)
       axios.post(url,formData).then(res=>{
        if(res.data.status === "Account Error")
        enqueueSnackbar(res.data.message, {
         variant: "error",
         anchorOrigin: {
           vertical: "bottom",
           horizontal: "right",
         },
       })
      
      else if(res.data.status === "Login Successful"){
        enqueueSnackbar(res.data.status, {
         variant: "success",
         anchorOrigin: {
           vertical: "bottom",
           horizontal: "right",
         },
       })
       Cookies.set("auth", res.data.Session, { expires: 1 })
       if(Cookies.get("auth"))
         user.setUser(Cookies.get("auth"))
         props.history.push("/dashboard")
      }
      }).catch((err)=>
      enqueueSnackbar("No internet connection", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      })
      )
    }
    else{
         enqueueSnackbar("All fields are required", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      })
    }
  }
  const processReset = (e) => {
    e.preventDefault()
    if(rEmail){
      let formData = new FormData()
      formData.append("Forgot_Email",rEmail)
       axios.post(url,formData).then(res=>{
         console.log(res);
        if(res.data.status === "Account Error")
        enqueueSnackbar(res.data.message, {
         variant: "error",
         anchorOrigin: {
           vertical: "bottom",
           horizontal: "right",
         },
       })
      
      else{
        enqueueSnackbar(res.data.status, {
         variant: "success",
         anchorOrigin: {
           vertical: "bottom",
           horizontal: "right",
         },
       })
       setREmail("")
      }
       })
    }
    else{
      enqueueSnackbar("Email field is required", {
     variant: "error",
     anchorOrigin: {
       vertical: "bottom",
       horizontal: "right",
     },
   })
 }
  }
  return (
    <div className="bts-landing-page-wrapper">
      <Navbar className="navbg d-md-none" expand="lg" fixed="top">
          <Navbar.Brand href="/">
            <img src={Logo} alt=""/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link href="/exchange" className="nav-items">Rates</Nav.Link>
              <Nav.Link href="/login" className="nav-items">Login</Nav.Link>
              <Nav.Link href="/register" className="nav-items">Register</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      <div className="bts-landing-page-caption-section">
          <div className="bts-landing-left-menu">
            <div className="bts-landing-page-caption-logo">
              <Link to="/">
                {/* <img src={Logo} alt="" className="logo"/> */}
                <img src={Logo} alt="" />
              </Link>
            </div>
            <div className="bts-landing-page-caption-links align-self-center d-flex justify-content-end">
                <Link to="/" className="notactive">Rates</Link>
                <Link to="/login" className="active">Login</Link>
                <Link to="/register" className="notactive">Register</Link>
            </div>
          </div>
          <Fade bottom delay={1000}>
            <div className="text-center push-top whiteText b7 mediumText">
              Hey! Welcome<br />Back &nbsp;
            <img src={Wave} alt="" />
            </div>
          </Fade>
          <Fade bottom delay={1200}>
            <p className="whiteText text-center pt-2 b3 medText">How is your day going?</p>
          </Fade>
          <Fade bottom delay={1500}>
            <div className="pt text-center">
              {!forgot?<form onSubmit={processSubmit}>
                  <div>
                    <input type="email" name="" onChange={(e)=>setEmail(e.target.value)} value={email} placeholder="Your email" id="emailInput"/>
                  </div>
                  <div>
                    <input type="password" name="" onChange={(e)=>setPassword(e.target.value)} value={password} placeholder="Password" id="pppppp" className="mt-4"/>
                  </div>
                  <div className="align-right pt-2">
                    <span onClick={()=>setForgot(true)} className="forgot-password">
                      forgot password?
                    </span>
                  </div>
                  <div>
                    <button type="submit" className="submitButton mt-2">Submit</button>
                  </div>
              </form> :
              <form onSubmit={processReset}>
              <div>
                <input type="email" name="" onChange={(e)=>setREmail(e.target.value)} value={rEmail} placeholder="Your email" id="emailInput"/>
              </div>
              
              <div className="align-right pt-2">
                <span onClick={()=>setForgot(false)} className="forgot-password">
                back to login
                </span>
              </div>
              <div>
                <button type="submit" className="submitButton mt-2">Submit</button>
              </div>
          </form>
              }
            </div>
          </Fade>
          <Fade delay={1600}>
            <div className="text-center">
              <div className=" b5 medText push">
                <Link to="/exchange" className="whiteText guest">
                  I'm a Guest
                </Link>
              </div>
              
            </div>
          </Fade>
      </div>
      <div className="bts-landing-page-testimonials">
        <div className="d-flex justify-content-between nav-align">
          <div className="ts-landing-page-right-menu align-self-center">
            <BTCRate/>
          </div>
          <div className="ts-landing-page-right-menu align-self-center">
            <Link to="tel:+2348162898892" className="blueText b7 medText plain">
              <img src={Phone} alt="" className="pr-3" /> Contact Us
            </Link>
          </div>
        </div>
        <div className="push-top">
          <>
            <Fade bottom delay={1200}>
              <Calculator />
              </Fade> 
          </>
          <div className="push-down">
            <img src={Banner} alt="" />
            <p className="pt-2">Supported payment methods</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
